//send form plugin
import $ from "jquery";
import f from "../funcs";

$.fn.sendForm = function(callback, validate) {

    return this.each(function() {

        let form = this
                ; let data = {}
                ; let $form = $(form)
                ; let method = ($form.attr("method") || "post").toUpperCase()
                ; let action = $form.attr("action")
                ; let isValid = true
			;

        $(this).on("submit", function(e) {
            e.preventDefault();

            data = getData($form);
            isValid = true;

            if ( f.isFunction(validate) ) {
                isValid = validate(data);
            }

            if ( isValid !== true ) {
                callback.call(form, isValid);
                return;
            }

            let xhr = new XMLHttpRequest()
                    ; let formData = new FormData( form )
				;

            xhr.open(method, action);
            xhr.withCredentials = true;
            xhr.onload = function() {
                let r = xhr.responseText;
                callback.call(form, r);
            };

            xhr.send(formData);
        });
    });
};

function getData($form) {
    let data = {};

    $form.find("[name]").each(function() {

        let input = this
                ; let $input = $(input)
                ; let name = $input.attr("name")
                ; let val = $input.val()
                ; let type = $input.attr("type")
			;

        if ( type == "checkbox" ) {
            val = +!!input.checked;
        }

        if ( type == "radio" ) {
            val = $form.find("[name=\"" + name + "\"]:checked").val();
        }

        data[ name ] = val;
    });

    return data;
}
